import { Component, input, OnInit } from '@angular/core';
import { faChevronRight, faUsers, faEdit } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { ReportService } from 'src/app/services/report.service';
import { SupportService } from 'src/app/services/support.service';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { EditAssessmentComponent } from 'src/app/routes/assessments/edit-assessment/edit-assessment.component';
import { AssessmentService } from 'src/app/services/assessment.service';

@Component({
    selector: 'supports',
    templateUrl: './supports.component.html',
    styleUrls: ['./supports.component.scss'],
    standalone: false
})


export class SupportsComponent implements OnInit {
  //icons
  faChevronRight = faChevronRight;
  faUsers = faUsers;
  faEdit = faEdit;

  //table variables
  reports = new MatTableDataSource<any>();
  rawReports: any;
  report_count = 0;
  displayedColumns = [
    'baer_name',
    'region',
    'support_status',
    'support_needed_type',
    'support_skills',
    'support_details',
    'actions'
  ];
  length = 0;
  reportCount = 5;

  //dropdown lists
  regions: any;
  statuses: any;
  complexities: any;
  team_leads: any;
  yearsArray: any;

  //access
  user = input.required<any>();
  isTeamLead: boolean = false;

  constructor(
    private readonly reportsService: ReportService,
    private readonly supportService: SupportService,
    private readonly titleService: Title,
    private readonly assessmentService: AssessmentService,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    if (this.user().teamLeadRoles) //keep highest privilage
      this.isTeamLead = true;
    this.loadReportData();

  }

  loadReportData() {
    this.supportService.getSupportList(1, this.reportCount, { support_completed: false }, "updated_on", "desc").subscribe({//this.filters).subscribe({
      next: (data) => {
        this.reports.data = data.supports;
        this.length = data.totalResults;
        this.reports.data.forEach((assessment: any) => {
          if (assessment.support_skills) {
            let skills = assessment.support_skills.split(", ");
            assessment.main_skill = skills[0];
            skills.shift();
            assessment.support_skills = skills.join("\n");
            assessment.other_skill_count = skills.length;
          }
        })

        this.reports.data.forEach((assessment: any) => {
          if (assessment.assessment_id)
            this.loadAssessmentData(assessment.assessment);
        });
      },
      complete: () => {
        return true;
      },
      error: (err) => {
        return false;
      }
    })
  }

  loadAssessmentData(assessment: any) {
    let reportRelations = '&relations=users.skills,users.user.skills,assessment,supporting_files,supports,soil_burn_severities,comments,forests,report_status';
    this.reportsService.getReportList(assessment.assessment_id, reportRelations).subscribe(
      {
        next: (data) => {
          let reports = data.reports;
          reports.sort((reportA: any, reportB: any) => reportA.report_num - reportB.report_num);
          assessment.reports = reports;
        }
      });
  }

  editBaerTeamNeeds(support: any): void {
    if (support.assessment) {
      this.dialog.open(EditAssessmentComponent, {
        maxWidth: "1000px",
        panelClass: ['animate__animated', 'animate__fadeInDown'],
        data: {
          fireRecord: support.assessment,
          isTeamLead: this.isTeamLead,
          user: this.user
        },
      }).afterClosed().subscribe((reload) => {
        this.titleService.setTitle("BAER - My Dashboard")
        if (reload) {
          this.loadReportData();
        }
      })
    } else {
      this.assessmentService.getAssessmentByID(support.report.assessment_id).subscribe({
        next: (data) => {
          this.dialog.open(EditAssessmentComponent, {
            maxWidth: "900px",
            panelClass: ['animate__animated', 'animate__fadeInDown'],
            data: {
              fireRecord: data,
              isTeamLead: this.isTeamLead,
              user: this.user
            },
          }).afterClosed().subscribe((reload) => {
            this.titleService.setTitle("BAER - Assessments")
            if (reload) {
              this.loadReportData();
            }
          })
        },
        complete: () => {
          return true;
        },
        error: (err) => {
          return false;
        }
      })
    }
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }
}